import { StreamTimeSeriesState } from 'widgets/store/stream/WidgetStreamState';
import { KeyedStreamItem } from 'communication/types/StreamElement';
import { StreamDisableRangeDataState } from 'widgets/store/disableRange/StreamDisableRangeDataState';
import {
    StreamsByStreamKeyState,
    StreamState,
} from 'streamsState/store/streamedData/StreamedDataState';

export type ObvTileStreamState = StreamState<ObvTileDataState>;
export type ObvStreamsState = StreamsByStreamKeyState<ObvTileDataState>;

export interface ObvTileDataState
    extends StreamTimeSeriesState<ObvTileDataStateTimeSeriesItem>,
        StreamDisableRangeDataState {
    orderStat?: {
        previousNightClose: number;
        exchangeRate: number;
        currencyCode: string;
    };
}

export interface ObvTileDataStateTimeSeriesItem extends KeyedStreamItem {
    close: number;
    volume: number;
    obv: number;
}

export const initialObvTileDataState: ObvTileDataState = {
    timeSeries: [],
    disableRange: [],
};

export const initialObvTileStreamState: ObvTileStreamState = {
    data: initialObvTileDataState,
    messages: [],
};

export const initialObvTileStreamsState: ObvStreamsState = {};
